import { SettingsPageTitle } from '@/modules/creator-settings/SettingsPageTitle'

import { useAiTranslatorToggle } from './use-ai-translator-toggle'

export const AiTranslatorToggle = () => {
  const { enabled, onToggle } = useAiTranslatorToggle()

  return (
    <SettingsPageTitle
      title="AI Translator"
      description={
        <span className="flex items-center gap-2">
          Use this setting to enable or disable the AI Translator for the
          selected creator in the dashboard.
        </span>
      }
      toggleName="Activate"
      enabled={enabled}
      onChange={onToggle}
    />
  )
}
